import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Typography } from '@dev/ee-components';
import { getFormCreatorStore } from '@/store/formCreator/actions';

export const Step1Content = (): JSX.Element => {
    const { t } = useTranslation();
    const { formObject } = useSelector(getFormCreatorStore);

    return (
        <>
            <Typography variant="h3">{t('formname')}:</Typography>
            <Typography variant="body1">{formObject?.Name}</Typography>
        </>
    );
};
